import { BASE_ROUTES, ROLES } from "utils";
import JWTDecoder from "jwt-decoder-claims";

class JwtWorker {

    //BEARER TOKEN META KEY 
    TOKEN_META_KEY = "OMNICHANNEL_AUTHORIZATION";
    APP_AUDIANCE = "omnichannel-app";
    storage = localStorage;//sessionStorage;

    //PERSIST ITEM IN LOCAL STORAGE
    setItemToStorage = (key, value) => {
        this.storage.setItem(key, JSON.stringify(value));
    }

    //DELETE ITEM FROM LOCAL STORAGE
    deleteItemFromStorage = (key) => {
        this.storage.removeItem(key);
    }

    //GET ITEM FROM LOCALSTORAGE
    getItemFromLocalStorage = (key) => {
        return JSON.parse(this.storage.getItem(key));
    }

    //GET BEARER TOKEN FROM STORAGE
    getTokenFromStorage = () => {
        return JSON.parse(this.storage.getItem(this.TOKEN_META_KEY));
    }

    //DECODING BEARER TOKEN
    decodeJWT = () => {
        const token = this.getTokenFromStorage()?.replace('Bearer ', '');
        return token ? JWTDecoder.payload(token) : null;
    }

    //RESOLVE USER ROLES FROM TOKEN
    getRolesFromToken = () => {
        return this.decodeJWT()?.roles;
    }

    //GET USERNMAE FROM TOKEN
    getSubFromToken = () => {
        return this.decodeJWT()?.sub;
    }

    //CHECK IF USER HAS THE APPROPRIATE PRIVILEGE
    isUserPriviliged = (role) => {
        return this.getRolesFromToken().includes(role);
    }

    //CHECK IF USER IS LOGGED
    isUserLogged = () => {
        try {
            return this.decodeJWT()?.aud === this.APP_AUDIANCE;
        } catch (err) {
            return false;
        }
    }

    //SET BEARER IN LOCAL STORAGE
    setTokenInStorage = (token) => {
        this.setItemToStorage(this.TOKEN_META_KEY, token);
    }

    //DELETE BEARER TOKEN FROM STORAGE
    removeTokenFromStorage = () => {
        this.deleteItemFromStorage(this.TOKEN_META_KEY);
    }

    //GET THE DEFAULT ROUTE
    getDefaultRoute = () => {
        return this.isUserLogged() ? this.getRolesFromToken().includes(ROLES.AGENT) ? BASE_ROUTES.FOLDERS_ROUTE :
            (this.getRolesFromToken().includes(ROLES.ADMIN) ? `${BASE_ROUTES.ADMIN_ROUTE}/users` :
                (this.getRolesFromToken().includes(ROLES.SUPERVISOR) ? `${BASE_ROUTES.SUPERVISION_ROUTE}/agents-status` :
                    BASE_ROUTES.ACCESS_DENIED)) : BASE_ROUTES.LOGIN;
    }

}

export default new JwtWorker();